import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import {
  ContentWrapper,
  EmptyStateWrapper,
} from './styled';

function EmptySearch() {
  return (
    <EmptyStateWrapper>
      <Image src="/illustration/search-friends-not-found.svg" alt="Empty Search Result" />
      <ContentWrapper>
        {/* @ts-expect-error */}
        <Text size="14px" mt="16px" color={color.highgray}>
          Tidak ada hasil yang ditemukan
        </Text>
      </ContentWrapper>
    </EmptyStateWrapper>
  );
}

export default EmptySearch;
